// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4EUAL","title":"styles_title__qx2WF","backgroundLinie":"styles_backgroundLinie__8n5Hx","row":"styles_row__p+3+F"};